<template>
    <div v-bind:id="'recipe-' + recipe.id" v-bind:class="[classes]">  
        <a v-bind:href="recipe.path" >
            <div class="image-wrapper lazy"> 
                <picture>
                    <img v-bind:src="recipe.card" /> 
                </picture>
            </div>
            <div v-if="recipe.smalltime" class="time"><i class="far fa-clock"></i> {{ recipe.smalltime }}</div>
            <div class="description-wrapper">
                <div class="description">
                    <h3>{{recipe.title}}</h3>
                </div> 
                <span class="actionicon heart" v-bind:class="{ active: recipe.isheart }" href="#" title="Klicken um das Rezept deinen Kochbüchern hinzuzufügen" v-bind:data-recipeid="recipe.id" @click.prevent="onClickHeart" >
                    <i class="far fa-heart"></i><i class="fas fa-heart d-none"></i>
                </span>
                <span class="actionicon calendar" href="#" title="Klicken um das Rezept deinem Planner hinzuzufügen" v-bind:data-recipeid="recipe.id" @click.prevent="onClickCalendar">
                    <i class="far fa-calendar-plus"></i>
                </span>  
            </div>

        </a>    
    </div>    

</template>

<script>

    export default {
        props: {
            recipe: Object,
            classes: {
                type: String,
                default: 'card small shadow recipe'
            },
        },
        data: function () {
            return {};
        },
        methods: {
            onClickHeart: function () {
                this.$emit('like',this, this.recipe);
            },
            onClickCalendar: function () {
                this.$emit('weekplan', this, this.recipe);
            }            
        }
    }
</script>

